/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IExtensibleComponentScope extends angular.IScope {
        model: models.ExtensibleComponentConfigurationModel
    }

    export class ManageExtensibleComponentController implements IController {
        constructor(
            private scope: IExtensibleComponentScope,
            $http: angular.IHttpService,
            $timeout: angular.ITimeoutService,
            growlService: angular.growl.IGrowlService,
            Upload: any) {
            this.scope.model = new models.ExtensibleComponentConfigurationModel($http, Upload, $timeout, growlService);
        }
    }
}

warsApp.registerController('ManageExtensibleComponentController', ['$scope','$http','$timeout','growl','Upload']);
